import { Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { JobPositionsService } from "../../job-positions.service";
import { locale as jobPositionsIt } from "../../i18n/jobPositionsIt";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { IFigure } from "app/auth/models/figures";

@Component({
  selector: "app-candidature-list",
  templateUrl: "./candidature-list.component.html",
  styleUrls: ["./candidature-list.component.scss"],
})
export class CandidatureListComponent implements OnInit {
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public candidateList: any[] = [];
  public filteredCandidateList: any[] = [];
  public figuresList: IFigure[] = [];
  public filterFigure: number = null;
  public selectedCandidate: any = null;

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    public _jobPositionsService: JobPositionsService,
    private _figureListService: UserFigureService,
    public _modalService: NgbModal,
  ) {
    this.contentHeader = {
      headerTitle: jobPositionsIt.data.CANDIDATURE,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: jobPositionsIt.data.CANDIDATURE,
            isLink: false,
          },
        ],
      },
    };
  }
  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_job_positions_candidature")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.figuresList = await this._figureListService.getList();
    await this.loadCandidature();
  }

  async loadCandidature() {
    this.candidateList = await this._jobPositionsService.getCandidature();
    this.filterList();
  }

  public modalOpen(whichModal, candidate: any) {
    if (!!candidate) {
      this.selectedCandidate = candidate;
      this._modalService.open(whichModal, {
        size: "md",
        centered: true,
      });
    }
  }
  updateTableLimit(event: any) {
    this.tableLimit = Number(event.target.value);
  }

  filterList() {
    let items: any[] = this.candidateList;
    const keywords: string = this.searchKeyword.trim();
    if (keywords.length > 0) {
      items = this.candidateList.filter(
        (item: any) =>
          item.firstname.toLowerCase().includes(this.searchKeyword.toLowerCase()) ||
          item.lastname.toLowerCase().includes(this.searchKeyword.toLowerCase()) ||
          item.city_name.toLowerCase().includes(this.searchKeyword.toLowerCase()),
      );
    }

    if (!!this.filterFigure) {
      items = this.candidateList.filter((item: any) => item.figure_id === this.filterFigure);
    }

    this.filteredCandidateList = items;
  }
  async transformToCandidate(candidate: any) {
    if (!this._authenticationService.hasCapability("create_candidate")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.router.navigate([`/dashboard/candidate/add`], { queryParams: { proposedCandidate: JSON.stringify(candidate) } });
  }
}
